import * as posActions from "../../lib/posActions";
import * as routeHelpers from "../../lib/routeHelpers";
import Checkbox from "../Checkbox";
import Drawer from "../Drawer";
import ManagerPermissionForm from "../ManagerPermissionForm";
import OutlineButton from "../OutlineButton";
import PaymentsMethodHeader from "../PaymentMethodsHeader";
import React, {useEffect, useState} from "react";
import styles from "./OtherPaymentMethods.module.css";
import {logManagerAction} from "../../lib/api/logs";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../lib/hooks";

const strings = {
    otherPaymentMethods: "Other Payment Options",
    orderSettingsSectionTitle: "Order Settings",
    fundraiser: "Fundraiser",
    ezCaterSectionTitle: "Ez Cater Payments",
    ezCaterPickup: "EzCater Pickup",
    ezCaterDelivery: "EzCater Delivery",
    otherPaymentTypesSectionTitle: "Other Payment Types",
    taxExempt: "Tax Exempt",
};

export function OtherPaymentMethods() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const supportedExternalTenders = useAppSelector(
        (state) => state.pos.store.supportedExternalTenders,
    );
    const cashier = useAppSelector((state) => state.pos.station.cashier);
    const [managerId, setManagerId] = useState(
        cashier?.type == "manager" ? cashier.managerId : null,
    );
    const stationMode = useAppSelector((state) => state.pos.station.mode);
    const taxExemptEnabled = useAppSelector(
        (state) => state.pos.store.taxExemptEnabled,
    );
    const orderIsTaxExempt = useAppSelector(
        (state) => state.pos.currentOrder.isTaxExempt,
    );
    const [showManagerPermissionsDrawer, setShowManagerPermissionsDrawer] =
        useState(false);

    useEffect(() => {
        if (cashier.type !== "manager") {
            setManagerId(null);
        }
    }, [cashier.type]);

    const handleChangeTaxExempt = () => {
        if (orderIsTaxExempt) {
            dispatch(posActions.setCurrentOrderIsTaxExempt(false));
            return;
        }

        if (!managerId) {
            setShowManagerPermissionsDrawer(true);
            return;
        }

        logManagerAction(
            "apply-entire-order-tax-exemption",
            managerId,
            stationMode,
        );
        dispatch(
            posActions.setStationCashier({
                type: "user",
            }),
        );
        dispatch(posActions.setCurrentOrderIsTaxExempt(true));
    };

    return (
        <>
            <div>
                <PaymentsMethodHeader
                    backPromptLabel={strings.otherPaymentMethods}
                    to={routeHelpers.payment()}
                />
                <div className={styles.paymentMethodOptionsContainer}>
                    <div className={styles.paymentMethodOptionsColumn}>
                        <span
                            className={styles.paymentMethodOptionsSectionTitle}>
                            {strings.orderSettingsSectionTitle}
                        </span>
                        <OutlineButton
                            className={styles.paymentMethodOptionButton}
                            label={strings.fundraiser}
                            onClick={() => {
                                navigate(routeHelpers.fundraiser());
                            }}
                        />
                        <span
                            className={styles.paymentMethodOptionsSectionTitle}>
                            {strings.ezCaterSectionTitle}
                        </span>
                        <OutlineButton
                            className={styles.paymentMethodOptionButton}
                            label={strings.ezCaterPickup}
                            onClick={() => {
                                dispatch(
                                    posActions.setCurrentOrderEzCaterOrderType(
                                        "pickup",
                                    ),
                                );
                                navigate(routeHelpers.ezCater());
                            }}
                        />
                        <OutlineButton
                            className={styles.paymentMethodOptionButton}
                            label={strings.ezCaterDelivery}
                            onClick={() => {
                                dispatch(
                                    posActions.setCurrentOrderEzCaterOrderType(
                                        "delivery",
                                    ),
                                );
                                navigate(routeHelpers.ezCater());
                            }}
                        />
                    </div>
                    {supportedExternalTenders.length > 0 || taxExemptEnabled ? (
                        <div className={styles.paymentMethodOptionsColumn}>
                            <span
                                className={
                                    styles.paymentMethodOptionsSectionTitle
                                }>
                                {strings.otherPaymentTypesSectionTitle}
                            </span>
                            {supportedExternalTenders.map((tender, i) => {
                                return (
                                    <OutlineButton
                                        key={i}
                                        className={
                                            styles.paymentMethodOptionButton
                                        }
                                        label={tender.name}
                                        onClick={() => {
                                            navigate(
                                                routeHelpers.externalTender(
                                                    tender.name,
                                                    tender.isTaxExempt,
                                                ),
                                            );
                                        }}
                                    />
                                );
                            })}
                            {taxExemptEnabled ? (
                                <Checkbox
                                    label={strings.taxExempt}
                                    checked={orderIsTaxExempt}
                                    onChange={handleChangeTaxExempt}
                                    disabled={showManagerPermissionsDrawer}
                                />
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
            {showManagerPermissionsDrawer ? (
                <Drawer
                    size="large"
                    onClose={() => setShowManagerPermissionsDrawer(false)}>
                    <div className={styles.managerPermissionFormContainer}>
                        <ManagerPermissionForm
                            onSuccess={(data) => {
                                setShowManagerPermissionsDrawer(false);
                                logManagerAction(
                                    "apply-entire-order-tax-exemption",
                                    data.id,
                                    stationMode,
                                );
                                dispatch(
                                    posActions.setCurrentOrderIsTaxExempt(true),
                                );
                            }}
                        />
                    </div>
                </Drawer>
            ) : null}
        </>
    );
}
